import { BORDER_COLORS as BC, SURFACE_COLORS as SC } from '@constants/colors.ts';
import { Radio } from 'antd';
import styled from 'styled-components';

export default styled(Radio)`
    &.ant-radio-wrapper {
        .ant-radio-checked .ant-radio-inner {
            border-color: ${BC.action};
            background-color: ${SC.action};
        }
        .ant-radio-disabled .ant-radio-inner {
            border-color: ${BC.disabled};
            background-color: ${SC.disabled};
        }
    }
`;
